import { getTimeActionTemplateRaw } from '@/screens/Order/Pages/Order.transform'
import { Modal, Button, Input, Select, Form } from 'antd'
import { useState } from 'react'
import { useQuery } from 'react-query'
import './ModalSaveTemplate.style.less'

interface Props {
  open: boolean
  onClose: () => void
  onSave: (value) => void
}

function ModalSaveTemplate(props: Props) {
  const [form] = Form.useForm()

  const [requiredName, setrequiredName] = useState(true)

  const { data: templates } = useQuery('GET_TEMPLATES', async () => {
    return await getTimeActionTemplateRaw()
  })

  const onSelectExistingTemplates = () => {
    setrequiredName(false)
    form.setFieldValue('name', '')
  }

  const onTypeInName = () => {
    setrequiredName(true)
    form.setFieldValue('templates', '')
  }

  return (
    <Modal
      title={<div className="modal-title">Time And Action Template</div>}
      className="order-template-container"
      open={props.open}
      onCancel={props.onClose}
      destroyOnClose
      width={365}
      centered
      footer={false}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Save as new Template"
          rules={[
            {
              required: requiredName,
              message: 'This field is required',
            },
          ]}
        >
          <Input
            onChange={onTypeInName}
            placeholder="Template Name"
            size="large"
          />
        </Form.Item>
        <Form.Item name="templates" label="Update an existing ">
          <Select
            placeholder="Select a Template (optional)"
            style={{ width: '100%' }}
            size="large"
            options={templates}
            onChange={onSelectExistingTemplates}
          />
        </Form.Item>
      </Form>
      <Button
        onClick={async () => {
          await form.validateFields()
          props.onSave(form.getFieldsValue())
        }}
        className="button-save"
        type="primary"
        size="large"
      >
        <span className="modal-btn-text">Save</span>
      </Button>
    </Modal>
  )
}

export default ModalSaveTemplate
